module.exports = __webpack_public_path__ + "img/Plan 0-1 Rendering.b33bcf02.jpg";